export const getFileExtension = (fileName = '') => {
  const splittedFileName = fileName.split('.');

  return splittedFileName.length > 1
    ? splittedFileName[splittedFileName.length - 1]
    : '';
};

export const removeSpaces = fileName => fileName.split(' ').join('_');

export const getMimeType = fileExt => {
  switch (fileExt) {
    case 'csv':
      return 'text/csv';
    case 'dat': case 'txt':
      return 'text/plain';
    case 'json':
      return 'application/json';
    case 'pdf':
      return 'application/pdf';
    case 'xls':
      return 'application/vnd.ms-excel';
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'zip':
      return 'application/zip';
    default:
      return 'application/octet-stream';
  }
};
